export default __webpack_public_path__ + "static/media/u_l.2d773c9f.wav";